// src/components/PremiumUniversityAdvisor.jsx
import React, { useState } from 'react';
import axios from 'axios';
import '../components/dashboard/Dashboard.css';

const PremiumUniversityAdvisor = ({ user }) => {
  const [mode, setMode] = useState(null);
  const [formData, setFormData] = useState({
    gpa: '',
    toefl: '',
    ielts: '',
    duolingo: '',
    notes: ''
  });
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    setPdfUrl(null);

    try {
      const requestData = new FormData();
      requestData.append('userId', user.id);
      requestData.append('mode', mode);

      if (mode === 'auto') {
        if (!files.length) {
          setError('Upload at least one document.');
          setLoading(false);
          return;
        }
        files.forEach(file => requestData.append('file', file));
      } else {
        Object.entries(formData).forEach(([key, value]) =>
          requestData.append(key, value)
        );
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/premium/generate`,
        requestData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      setPdfUrl(res.data.pdfUrl);
    } catch (err) {
      console.error(err);
      setError('Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="premium-advisor">
      {!mode && (
        <div className="mode-selector">
          <h3>🔍 How would you like to proceed?</h3>
          <button onClick={() => setMode('manual')}>📝 Fill Manually</button>
          <button onClick={() => setMode('auto')}>📄 Upload Document</button>
        </div>
      )}

      {mode === 'manual' && (
        <div className="form-section">
          <h4>Enter your academic profile</h4>
          <input placeholder="GPA" value={formData.gpa}
            onChange={e => setFormData({ ...formData, gpa: e.target.value })} />
          <input placeholder="TOEFL" value={formData.toefl}
            onChange={e => setFormData({ ...formData, toefl: e.target.value })} />
          <input placeholder="IELTS" value={formData.ielts}
            onChange={e => setFormData({ ...formData, ielts: e.target.value })} />
          <input placeholder="Duolingo" value={formData.duolingo}
            onChange={e => setFormData({ ...formData, duolingo: e.target.value })} />
          <textarea placeholder="Extra Notes" value={formData.notes}
            onChange={e => setFormData({ ...formData, notes: e.target.value })} />
        </div>
      )}

      {mode === 'auto' && (
        <div className="upload-section">
          <h4>Upload your academic documents (PDF, Image)</h4>
          <input type="file" accept=".pdf,.jpg,.jpeg,.png" multiple
            onChange={e => setFiles([...e.target.files])} />
          {files.length > 0 && (
            <ul>{files.map((f, i) => <li key={i}>{f.name}</li>)}</ul>
          )}
        </div>
      )}

      {mode && (
        <>
          <button onClick={handleSubmit} disabled={loading}>
            {loading ? 'Generating PDF...' : 'Generate PDF Report'}
          </button>
          <button className="back-btn" onClick={() => setMode(null)}>
            ← Back
          </button>
        </>
      )}

      {error && <p className="error">{error}</p>}
      {pdfUrl && (
        <div className="result-box">
          <p>🎉 Your PDF is ready!</p>
          <a href={pdfUrl} download target="_blank" rel="noopener noreferrer">
            Download Report
          </a>
        </div>
      )}
    </div>
  );
};

export default PremiumUniversityAdvisor;
